export { downloadPhoto } from './downloadPhoto';



// WEBPACK FOOTER //
// ./src/lib/plugins/index.js